<div id="broadcast-filter-head" [ngClass]="{ 'filter-head': broadcastType != appValues.welcomeMessageParams, 'filter-head-single': broadcastType === appValues.welcomeMessageParams }">
    <div class="mat-headline-6 mb-16">Filters</div>
    <p class="mat-subtitle-2 text-hint" [ngClass]="{ 'm-0': (broadcastType == appValues.broadcastParams || broadcastType == appValues.surveyParams) }">{{ filterNote }}</p>
</div>

<mat-divider id="broadcast-filter-head-divider" class="mb-16"></mat-divider>

<div id="broadcast-filter-option" class="px-8">
    <mat-form-field *ngIf="hasFilterOptions" appearance="outline" class="end-input">
        <mat-label>Show options for</mat-label>
        <mat-select #filterOption [value]="filtersFor" [disabled]="disabled">
            <mat-option class="text-normal" [value]="broadcastFilterMethod.massBroadcast.method"
                (click)="switchFilters(broadcastFilterMethod.massBroadcast.method, filterOption)"
                [disabled]="false"
            >{{broadcastFilterMethod.massBroadcast.label}}</mat-option>
            <mat-option 
            class="text-normal" 
                [value]="broadcastFilterMethod.individualBroadcast.method"
                (click)="switchFilters(broadcastFilterMethod.individualBroadcast.method, filterOption)"
                [disabled]="false"
            >{{broadcastFilterMethod.individualBroadcast.label}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<!-- BH-10704: caregivers = people with at least one member linked to them. Needed by @associated_recipients. -->
<div *ngIf="broadcastType == appValues.broadcastParams" id="broadcast-filter-caregivers-only"
    class="caregivers-only ml-8 mr-8 mb-16" [class.caregivers-only--required]="caregiversOnlyRequired">
    <mat-checkbox [(ngModel)]="caregiversOnly" [disabled]="disabled" aria-describedby="caregivers-only-hint">
        <span class="caregivers-only__title">Linked caregivers</span>
    </mat-checkbox>
    <div id="caregivers-only-hint" class="caregivers-only__hint">{{ broadcastMessages.SEND_FORM.LINKED_CAREGIVERS_HELPER }}</div>
</div>

<ng-container [ngSwitch]="filtersFor">
    <ng-container *ngSwitchCase="broadcastFilterMethod.individualBroadcast.method">
        <a *ngIf="disabled; else activeLinkTemp" class="mat-body-strong text-hint px-16 mb-16">Select Specific
            Individual Recipients</a>
        <ng-template #activeLinkTemp>
            <a (click)="individualUsersSelector?.emit()" class="mat-body-strong secondary-text px-16 mb-16"
                style="text-decoration: underline; cursor: pointer;">Select Specific Individual Recipients</a>
        </ng-template>

        <div *ngIf="userSelectorData?.selectedUsers?.length" class="audience mt-12 fs-14">
            <mat-accordion>
                <mat-expansion-panel expanded>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subtitle-1 text-hint mb-4"> 
                            <span class="mr-4">Selected Members* </span>
                            <span>({{userSelectorData?.selectedUsers?.length}})</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                        <mat-checkbox *ngFor="let _selectedUser of userSelectorData?.selectedUsers"
                            (click)="$event.stopPropagation()"
                            (change)="$event ? toggleSelectionData(_selectedUser) : null"
                            [checked]="isSelectedItem(_selectedUser)"
                            [matTooltip]="_selectedUser.fname + ' ' + _selectedUser.lname"
                            matTooltipClass="mat-tooltip-style"
                            [matTooltipDisabled]="needToolTip(_selectedUser.fname + ' ' + _selectedUser.lname)"
                            [disabled]="disabled || !!leftOutReasons[_selectedUser.member_ref]"
                            [class.left-out]="!!leftOutReasons[_selectedUser.member_ref]" style="
                                height: 40px;
                                display: flex;
                                align-items: center;
                                width: 100%;
                                padding-left: 8px;
                                margin-bottom: 4px;
                            ">
                            <div class="d-flex flex-column" style="width: 240px;">
                                <div class="text-truncate">
                                    {{ _selectedUser.fname + ' ' + _selectedUser.lname }}
                                </div>
                                <div *ngIf="!leftOutReasons[_selectedUser.member_ref]" class="mat-caption text-hint text-truncate"
                                    [matTooltip]="_selectedUser?.Programs?.name || NoProgramValue.name"
                                    matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="_selectedUser?.Programs?.name ? needToolTip(_selectedUser.Programs?.name || '') : true">
                                    {{_selectedUser?.Programs?.name || NoProgramValue.name}}
                                </div>
                                <!-- BH-10704: C-5 / C-6. Text reason, so colour isn't the only signal. -->
                                <div *ngIf="leftOutReasons[_selectedUser.member_ref] as reason" class="mat-caption text-truncate left-out__reason">
                                    {{ reason }}
                                </div>
                            </div>

                        </mat-checkbox>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <div class="audience fs-14">
            <mat-accordion>
                <mat-expansion-panel [expanded]="!!audiances">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"> Audience <span class="ml-4">*</span> </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div *ngIf="!audiances?.seniorCenters?.length" class="mat-caption warn-text">{{filterWarn}}</div>
                    <!-- Audiences -->
                    <div *ngIf="audiances && audiances?.seniorCenters?.length">
                        <mat-checkbox class="lh-40 filter-wrap" [id]="audiances.name" [checked]="audiances.checkAll"
                            [indeterminate]="someChecked()" (change)="setCheckAll($event.checked)"
                            [matTooltip]="audiances.name" matTooltipClass="mat-tooltip-style"
                            [matTooltipDisabled]="needToolTip(audiances.name)" [disabled]="disabled">
                            {{ audiances.name }}
                        </mat-checkbox>
                        <ul>
                            <li *ngFor="let sc of audiances.seniorCenters">
                                <mat-checkbox [id]="sc.name" (change)="updateCheckAll()" [(ngModel)]="sc.checked"
                                    [matTooltip]="sc.name" matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(sc.name)" class="filter-wrap child"
                                    [disabled]="disabled">{{ sc.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel [disabled]="!orgLabels?.organizationLabels?.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title
                        class="mat-subheading-2 mb-4"
                        [ngClass]="{ 'text-hint': orgLabels?.organizationLabels?.length, 'text-disabled': !orgLabels?.organizationLabels?.length }"
                    >
                        Labels
                    </mat-panel-title>
                    </mat-expansion-panel-header>
                    <!-- Labels -->
                    <div *ngIf="orgLabels && orgLabels?.organizationLabels?.length">
                        <mat-checkbox class="lh-40 filter-wrap" [id]="'labels_' + orgLabels.name"
                            [checked]="orgLabels.checkAll" [indeterminate]="someLabelsChecked()"
                            (change)="setCheckAllLabels($event.checked)" [matTooltip]="orgLabels.name"
                            matTooltipClass="mat-tooltip-style" [matTooltipDisabled]="needToolTip(orgLabels.name)"
                            [disabled]="disabled">
                            {{ orgLabels.name }}
                        </mat-checkbox>
                        <ul>
                            <li *ngFor="let orgLabel of orgLabels.organizationLabels">
                                <mat-checkbox [id]="orgLabel.name" (change)="updateCheckAllLabels()"
                                    [(ngModel)]="orgLabel.checked" [matTooltip]="orgLabel.name"
                                    matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(orgLabel.name)" class="filter-wrap child"
                                    [disabled]="disabled">{{ orgLabel.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>

                <ng-container
                    *ngIf="(broadcastType == appValues.welcomeMessageParams || broadcastType == appValues.broadcastParams || broadcastType == appValues.surveyParams) && orgInfo">
                    <mat-expansion-panel *ngIf="bUserInterests?.length">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="mat-subheading-2 mb-4 text-hint"> Interests </mat-panel-title>
                        </mat-expansion-panel-header>
                        <!-- Interests -->
                        <div>
                            <ng-container *ngFor="let interest of bUserInterests">
                                <mat-checkbox class="lh-40 filter-wrap" [id]="interest.id + ''"
                                    [(ngModel)]="interest.checked" [matTooltip]="interest.name"
                                    matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(interest.name)" [disabled]="disabled">
                                    {{ interest.name }}
                                </mat-checkbox>
                            </ng-container>
                        </div>
                    </mat-expansion-panel>
                </ng-container>
            </mat-accordion>
            <!-- Advanced Audience Filters Section -->
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-subheading-2 text-hint mb-4">Advanced Audience Filters</mat-panel-title>
                </mat-expansion-panel-header>
                
                <!-- Age -->
                <mat-expansion-panel [disabled]="!ageFilters.hasData">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': ageFilters.hasData, 'text-disabled': !ageFilters.hasData}">Age</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-checkbox [disabled]="disabled" class="lh-40 filter-wrap" [(ngModel)]="ageFilters.enabled"
                        (change)="onAgeFilterToggle($event.checked)">
                        Select Range
                    </mat-checkbox>
                    <div class="age-filter-container" [class.has-error]="ageFilters.hasError || ageValidationError">
                        <div *ngIf="ageFilters.hasError && !ageValidationError" class="error">
                            Invalid age range: Minimum age cannot be greater than maximum age
                        </div>
                        <div *ngIf="ageValidationError && !ageFilters.hasError" class="error">
                            {{ ageValidationError }}
                        </div>
            
                        <div class="age-inputs">
                            <div class="age-input-group">
                                <label class="age-label">Min</label>
                                <input type="number" class="age-input" [class.error]="ageFilters.hasError || ageValidationError"
                                    [(ngModel)]="ageFilters.minValue" (ngModelChange)="onAgeChange($event, 'min')"
                                    [min]="ageFilters.min" [max]="ageFilters.max" [disabled]="isDisabledAge()">
                            </div>
                            <div class="age-input-group">
                                <label class="age-label">Max</label>
                                <input type="number" class="age-input" [class.error]="ageFilters.hasError || ageValidationError"
                                    [(ngModel)]="ageFilters.maxValue" (ngModelChange)="onAgeChange($event, 'max')"
                                    [min]="ageFilters.min" [max]="ageFilters.max" [disabled]="isDisabledAge()">
                            </div>
                        </div>
                        <div class="range-slider-container">
                            <mat-slider [min]="ageFilters.min" [max]="ageFilters.max" [disabled]="isDisabledAge()" discrete="true"
                                [displayWith]="formatLabel">
                                <input matSliderStartThumb [(ngModel)]="ageFilters.minValue" (valueChange)="onAgeChange($event, 'min')">
                                <input matSliderEndThumb [(ngModel)]="ageFilters.maxValue" (valueChange)="onAgeChange($event, 'max')">
                            </mat-slider>
                        </div>
                    </div>
                </mat-expansion-panel>
            
                <!-- Disability Status -->
                <mat-expansion-panel [disabled]="!disabilityFilters.options.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': disabilityFilters.options.length, 'text-disabled': !disabilityFilters.options.length}">Disability
                            Status</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-checkbox class="lh-40 filter-wrap" [checked]="disabilityFilters.checkAll"
                            [indeterminate]="someFilterChecked(disabilityFilters)"
                            (change)="setCheckAllDemographic(disabilityFilters, $event.checked)" [disabled]="disabled">
                            Select All
                        </mat-checkbox>
                        <ul>
                            <li *ngFor="let disability of disabilityFilters.options">
                                <mat-checkbox (change)="updateCheckAllDemographic(disabilityFilters, 'disability')"
                                    [(ngModel)]="disability.checked" [matTooltip]="disability.name"
                                    matTooltipClass="mat-tooltip-style" [matTooltipDisabled]="needToolTip(disability.name)"
                                    class="filter-wrap child" [disabled]="disabled">
                                    {{ disability.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>
            
                <!-- Gender -->
                <mat-expansion-panel [disabled]="!genderFilters.options.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': genderFilters.options.length, 'text-disabled': !genderFilters.options.length}">Gender</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-checkbox class="lh-40 filter-wrap" [checked]="genderFilters.checkAll"
                            [indeterminate]="someFilterChecked(genderFilters)"
                            (change)="setCheckAllDemographic(genderFilters, $event.checked)" [disabled]="disabled">
                            Select All
                        </mat-checkbox>
                        <ul>
                            <li *ngFor="let gender of genderFilters.options">
                                <mat-checkbox (change)="updateCheckAllDemographic(genderFilters, 'gender')"
                                    [(ngModel)]="gender.checked" [matTooltip]="gender.name" matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(gender.name)" class="filter-wrap child" [disabled]="disabled">
                                    {{ gender.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>
            
                <!-- Language -->
                <mat-expansion-panel [disabled]="!languageFilters.options.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': languageFilters.options.length, 'text-disabled': !languageFilters.options.length}">Language</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-checkbox class="lh-40 filter-wrap" [checked]="languageFilters.checkAll"
                            [indeterminate]="someFilterChecked(languageFilters)"
                            (change)="setCheckAllDemographic(languageFilters, $event.checked)" [disabled]="disabled">
                            Select All
                        </mat-checkbox>
                        <div class="custom-search">
                            <input type="text" [(ngModel)]="languageFilters.searchTerm" placeholder="Search" [disabled]="disabled">
                            <mat-icon class="search-icon">search</mat-icon>
                        </div>
                        <ul>
                            <li *ngFor="let language of filteredLanguages">
                                <mat-checkbox (change)="updateCheckAllDemographic(languageFilters, 'language')"
                                    [(ngModel)]="language.checked" [matTooltip]="language.name" matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(language.name)" class="filter-wrap child"
                                    [disabled]="disabled">
                                    {{ language.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>
            
                <!-- Race/Ethnicity -->
                <mat-expansion-panel [disabled]="!raceFilters.options.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': raceFilters.options.length, 'text-disabled': !raceFilters.options.length}">Race/Ethnicity</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-checkbox class="lh-40 filter-wrap" [checked]="raceFilters.checkAll"
                            [indeterminate]="someFilterChecked(raceFilters)"
                            (change)="setCheckAllDemographic(raceFilters, $event.checked)" [disabled]="disabled">
                            Select All
                        </mat-checkbox>
                        <ul>
                            <li *ngFor="let race of raceFilters.options">
                                <mat-checkbox (change)="updateCheckAllDemographic(raceFilters, 'race')" [(ngModel)]="race.checked"
                                    [matTooltip]="race.name" matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(race.name)" class="filter-wrap child" [disabled]="disabled">
                                    {{ race.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>
            
                <!-- Veteran Status -->
                <mat-expansion-panel [disabled]="!veteranFilters.options.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': veteranFilters.options.length, 'text-disabled': !veteranFilters.options.length}">Veteran
                            Status</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-checkbox class="lh-40 filter-wrap" [checked]="veteranFilters.checkAll"
                            [indeterminate]="someFilterChecked(veteranFilters)"
                            (change)="setCheckAllDemographic(veteranFilters, $event.checked)" [disabled]="disabled">
                            Select All
                        </mat-checkbox>
                        <ul>
                            <li *ngFor="let veteran of veteranFilters.options">
                                <mat-checkbox (change)="updateCheckAllDemographic(veteranFilters, 'veteran')"
                                    [(ngModel)]="veteran.checked" [matTooltip]="veteran.name" matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(veteran.name)" class="filter-wrap child"
                                    [disabled]="disabled">
                                    {{ veteran.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>
            
                <!-- Zip Code -->
                <mat-expansion-panel [disabled]="!zipCodeFilters.options.length">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 text-hint mb-4"
                            [ngClass]="{ 'text-hint': zipCodeFilters.options.length, 'text-disabled': !zipCodeFilters.options.length}">Zip
                            Code</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <div *ngIf="filteredZipCodes.length === 0" class="error">
                            No zip codes available
                        </div>
                        <mat-checkbox class="lh-40 filter-wrap" [checked]="zipCodeFilters.checkAll"
                            [indeterminate]="someFilterChecked(zipCodeFilters)"
                            (change)="setCheckAllDemographic(zipCodeFilters, $event.checked)" [disabled]="disabled">
                            Select All
                        </mat-checkbox>
                        <div class="custom-search">
                            <input type="text" [(ngModel)]="zipCodeFilters.searchTerm" placeholder="Search" [disabled]="disabled">
                            <mat-icon class="search-icon">search</mat-icon>
                        </div>
                        <ul>
                            <li *ngFor="let zipCode of filteredZipCodes">
                                <mat-checkbox (change)="updateCheckAllDemographic(zipCodeFilters, 'zipcode')"
                                    [(ngModel)]="zipCode.checked" [matTooltip]="zipCode.name" matTooltipClass="mat-tooltip-style"
                                    [matTooltipDisabled]="needToolTip(zipCode.name)" class="filter-wrap child"
                                    [disabled]="disabled">
                                    {{ zipCode.name }}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>

                <!-- Activation Date -->
                <mat-expansion-panel [disabled]="!filtersLoaded">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subheading-2 mb-4" [ngClass]="{ 'text-hint': filtersLoaded, 'text-disabled': !filtersLoaded }">Activation Date</mat-panel-title>
                    </mat-expansion-panel-header>
                    <p class="mat-caption text-hint activation-date-hint">Target users activated within a specific window.</p>
                    <div class="activation-date-inputs">
                        <div class="activation-date-group">
                            <label class="activation-date-label">From</label>
                            <mat-form-field appearance="outline" class="add-custom-css activation-date-field">
                                <mat-label>Select date</mat-label>
                                <input matInput [matDatepicker]="fromPicker"
                                    [(ngModel)]="activationDateFilter.from"
                                    (dateChange)="onActivationDateChange()"
                                    (click)="fromPicker.open()"
                                    [max]="activationDateFilter.to || today"
                                    [disabled]="disabled"
                                    readonly>
                                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                                <mat-datepicker #fromPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="activation-date-group">
                            <label class="activation-date-label">To</label>
                            <mat-form-field appearance="outline" class="add-custom-css activation-date-field">
                                <mat-label>Select date</mat-label>
                                <input matInput [matDatepicker]="toPicker"
                                    [(ngModel)]="activationDateFilter.to"
                                    (dateChange)="onActivationDateChange()"
                                    (click)="toPicker.open()"
                                    [min]="activationDateFilter.from"
                                    [max]="today"
                                    [disabled]="disabled"
                                    readonly>
                                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                                <mat-datepicker #toPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-expansion-panel>

            <!-- User Custom Fields -->
            
            <mat-expansion-panel *ngIf="showCustomFieldSection" [disabled]="!customFieldFilters.options.length">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-subheading-2 mb-4"
                        [ngClass]="{ 'text-hint': customFieldFilters.options.length, 'text-disabled': !customFieldFilters.options.length}">
                        User Custom Fields
                    </mat-panel-title>
                </mat-expansion-panel-header>
            
                <ng-container *ngFor="let customField of customFieldFilters.options">
            
                    <mat-expansion-panel *ngIf="customFieldFilters.options.length">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="mat-subheading-2 text-hint mb-4" [ngClass]="{
                        'text-hint': customField.values?.length || customField.name,
                        'text-disabled': !customField.values?.length && !customField.name
                      }">
                                {{ customField.name }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
            
                        <div>
                            <!-- Select All checkbox - only for multi-type fields -->
                            <mat-checkbox *ngIf="customField.field_type === 'multi'" class="lh-40 filter-wrap"
                                [checked]="customField.checkAll" [indeterminate]="someCustomFieldValuesChecked(customField)"
                                (change)="setCheckAllCustomField(customField, $event.checked)" [disabled]="disabled">
                                Select All
                            </mat-checkbox>
            
                            <!-- Parent checkbox for fields without values (single-type) -->
                            <mat-checkbox *ngIf="!customField.values || customField.values.length === 0"
                                (change)="updateCustomFieldValue(customField)" [(ngModel)]="customField.checked"
                                [matTooltip]="customField.name" matTooltipClass="mat-tooltip-style"
                                [matTooltipDisabled]="needToolTip(customField.name)" class="filter-wrap child"
                                [disabled]="disabled">
                                {{ customField.name }}
                            </mat-checkbox>
            
                            <!-- For all fields with values - use checkboxes -->
                            <ul *ngIf="customField.values && customField.values.length > 0">
                                <li *ngFor="let value of customField.values">
                                    <mat-checkbox (change)="onCustomFieldCheckboxChange(customField, value, $event)"
                                        [(ngModel)]="value.checked" [matTooltip]="value.value" matTooltipClass="mat-tooltip-style"
                                        [matTooltipDisabled]="needToolTip(value.value)" class="filter-wrap child"
                                        [disabled]="disabled">
                                        {{ value.value }}
                                    </mat-checkbox>
                                </li>
                            </ul>
                        </div>
                    </mat-expansion-panel>
            
                </ng-container>
            </mat-expansion-panel>
        </div>
    </ng-container>
</ng-container>

<ng-template #selfCareGiverFieldTemp>
    <mat-checkbox [disabled]="disabled" class="lh-40 filter-wrap" [(ngModel)]="selfCareGiver.checked">{{
        selfCareGiver.name }} </mat-checkbox>
    <mat-radio-group [(ngModel)]="selfCareGiver.value" [disabled]="!selfCareGiver.checked || disabled"
        aria-label="Select an option for self caregiver">
        <ul>
            <li *ngFor="let opt of selfCaregiverOptions">
                <mat-radio-button [value]="opt.value" class="filter-wrap child"> {{opt.label}} </mat-radio-button>
            </li>
        </ul>
    </mat-radio-group>
</ng-template>